import { makeStyles } from '@material-ui/core';
import { rem, vh } from 'src/common/helpers/dimension-helper';
import { themeColor } from 'src/mui-theme';

// Until the theme gets typed...
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const keypadInputFieldStyles = makeStyles((theme: any) => ({
  uomText: {
    paddingLeft: '0.43vw',
    paddingTop: '0.43vw',
  },
  inputContainer: {
    height: '7.29vh',
    backgroundColor: themeColor.lightBackground,
    width: '100%',
    borderBottom: `3px solid ${theme?.configColors?.secondaryColor ||
      theme.palette.secondary.main}`,
    paddingLeft: '0.73vw',
    borderRadius: '2px 2px 0 0',
  },
  helperText: {
    paddingTop: '0.43vw',
  },
  forceQuantityHelperText: {
    fontSize: vh(1.56),
    paddingTop: '0.43vw',
    lineHeight: '2.08vh',
    letterSpacing: '0.02vw',
    color: theme.palette.info.main,
  },
  input: {
    padding: 0,
  },
  priceModeInput: {
    padding: 0,
    textAlign: 'end',
  },
  keypadAdjustOverflow: {
    '@media (max-height: 720px)': {
      fontSize: rem(0.75),
    },
    '@media (max-height: 576px)': {
      fontSize: rem(0.5),
    },
  },
  clearInputButtonContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  clearButton: {
    '@media (max-width: 1366px)': {
      minWidth: 0,
    },
  },
  caption: {
    fontWeight: 400,
    color: theme.palette.info.main,
    paddingTop: '0.88vh',
  },
  truncateInputFieldLabel: {
    width: 'inherit',
  },
}));
